<div class="modal right" id="uberMenuItem" tabindex="-1" role="dialog" aria-labelledby="uberMenuItemLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
					<h4 id="uberMenuItemLabel" ng-if="modalType === 'new_item'">New Item</h4>
                    <h4 id="uberMenuItemLabel" ng-if="modalType === 'edit_item'">Edit Item</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
									<form ng-submit="saveItem(selectedItem)" class="form-horizontal allcp-form" autocomplete="off">
										<h4 style="font-size:13px">Item Info</h4>
										<div class="row">
											<div class="col-md-12 pl15">
												<div class="form-group floating">
													<input type="text" ng-model="selectedItem.title.translations.en" class="form-control input-md" placeholder="Name" required>
													<label>Name</label>
												</div>
											</div>
											<div class="col-md-12 pr10">
												<div class="form-group floating">
													<input type="text" ng-model="selectedItem.description.translations.en" class="form-control input-md" placeholder="Description">
													<label>Description</label>
												</div>
											</div>
										</div>

										<div class="form-group floating">
											<input type="number" ng-model="selectedItem.price_info.price" string-to-number class="form-control input-md" placeholder="Price" required>
											<label>Price * (You must enter the price multiplied by 100)</label>
										</div>

										<div class="form-group floating mt-5">
											<label class="mb-2">Categories : </label>
											<ui-select 
												multiple 
												ng-model="selectedData.categories"
												theme="bootstrap" 
												sortable="true" 
												class="gui-input br-light light" 
												style="width: 100%;"
												title="Categories">
												<ui-select-match placeholder="Categories...">{{$item.title.translations.en}}</ui-select-match>
												<ui-select-choices repeat="item in data.menu.categories | filter:$select.search | orderBy: 'title.translations.en'">
													{{item.title.translations.en}}
												</ui-select-choices>
											</ui-select>
										</div>

										<div class="form-group floating mt-5">
											<label class="mb-2">Modifier Groups : </label>
											<ui-select 
												multiple 
												ng-model="selectedData.modifiers"
												theme="bootstrap" 
												sortable="true" 
												class="gui-input br-light light" 
												style="width: 100%;"
												title="Modifier Groups">
												<ui-select-match placeholder="Modifier Groups...">{{$item.title.translations.en}}</ui-select-match>
												<ui-select-choices repeat="item in data.menu.modifier_groups | filter:$select.search | orderBy: 'title.translations.en'">
													{{item.title.translations.en}}
												</ui-select-choices>
											</ui-select>
										</div>

										<div class="form-group floating">
											<div class="fileupload fileupload-new mb-3" data-provides="fileupload">
												<div class="fileupload-preview thumbnail">
													<img ng-if="selectedItem.logo" 
														class="img-responsive center" 
														style="height:220px"
														ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ selectedItem.logo }}" />

													<img ng-src="{{ selectedItem.image_url }}" 
														class="img-responsive text-center icon-drag-icon" 
														width="72px" height="72px" style="width:72px;  height:72px;" 
														ng-if="selectedItem.image_url">
													<a href="" class="text-danger" ng-if="selectedItem.image_url" ng-click="removeImage()">Remove Image</a>

													<div class="line-seperator" ng-if="selectedItem.image_url">
														<div class="line"></div>
														<p></p>
														<div class="line"></div>
													</div>
													<div class="logo_upload" ng-repeat="item in logo.queue" style="width:50%">
														<div class="progress" ng-if="proccessProfile">
															<div 
																class="progress-bar progress-bar-success progress-bar-striped active" 
																role="progressbar" 
																aria-valuenow="60" 
																aria-valuemin="0" 
																aria-valuemax="100" 
																ng-style="{ 'width': item.progress + '%' }"
																>
															</div>
														</div>
													</div>
													<span class="btn btn-outline btn-file">
														<span class="fileupload-new" ng-if="selectedItem.image_url">Update Image</span>
														<span class="fileupload-new" ng-if="!selectedItem.image_url">Add Image</span>
														<input type="file" nv-file-select uploader="logo">
													</span>
												</div>
											</div>
											<p class="help-block">
												Image requirements: <br>
												File size < 25MB <br>
												JPG, WEBP or PNG format <br>
												320px ≤ Width ≤ 6000px <br>
												320px ≤ Height ≤ 6000px
											</p>
										</div>


										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue" ng-disabled="loading">
													<span ng-if="modalType === 'new_item'">CREATE</span>
                    								<span ng-if="modalType === 'edit_item'">UPDATE</span>
												</a>
											</div>
										</div>

									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
